import Vue from 'vue';
const BfSlider = Vue.extend({
    props: {
        value: { type: Number, required: true },
        min: { type: Number, required: true },
        max: { type: Number, required: true },
        step: { type: Number, required: false, default: 1 }
    }
});
export default BfSlider;
